import { Component, Input } from '@angular/core';

@Component({
  selector: 'itl-desktop-page-list',
  templateUrl: './desktop-page-list.component.html',
  styleUrls: ['./desktop-page-list.component.scss'],
})
export class DesktopPageListComponent {
  @Input() noSearchbar = false;
}
